var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"error-page"},[_vm._v("Страница не найдена")])])])
}]

export { render, staticRenderFns }